import { popupContext } from "../../../contextAdmin/Admin/Popup";
import React, { useEffect, useState } from "react";

import Header from "../Header";
import Popup from "../Popup";

import "./style.css";
import authRequets from "../../api/authRequests";
import { listControllerContext } from "../../../contextAdmin/Admin/List";
import { HeaderTextContext } from "../../../contextAdmin/hederText";
import { userContext } from "../../../contextAdmin/Admin/User";

import fakeData from "../../../contextAdmin/Admin/StudentData/fakedata";
import { studentDataContext } from "../../../contextAdmin/Admin/StudentData";

import { classList } from "../../../pages/Admin/Classrooms/data";
import { updateAuthorizationHeader } from "../../api/mainAxios";
import classRequets from "../../api/classRequest";
import adminRequets from "../../api/adminRequests";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../../api/firabaseConfig";

// Creator : Team E - bezalel

function AdminProvider({ children }) {
  const [popup, setPopup] = useState(false);
  const [list, setList] = useState([]);
  const [user, setUser] = useState();
  const [studentData, setstudentData] = useState([]);
  const [headerText, setHeaderText] = useState("");
  const [classData, setClassData] = useState("")
  // signOut(auth)

  useEffect(() => {
    if (localStorage.access_token) {
      try {
        setTimeout(() => {

          const auth = getAuth();
          console.log("🚀 ~ file: AdminProvider.jsx:37 ~ useEffect ~ auth:", auth)
          // onAuthStateChanged(auth, (user) => {
          if (auth.currentUser) {
            console.log("🚀 ~ file: AdminProvider.jsx:34 ~ onAuthStateChanged ~ user:", auth.currentUser)
            // User is signed in, see docs for a list of available properties
            // https://firebase.google.com/docs/reference/js/auth.user

            authRequets.trylogin(auth.currentUser).then(res => {
              console.log("🚀 ~ file: AdminProvider.jsx:39 ~ authRequets.trylogin ~ res:", res)
              setUser(res)
            })
            // ...
          } else {
            // User is signed out
            // ...
          }
          // });
        }, 1000)
      } catch (error) {
        console.log("🚀 ~ file: authRequests error:", error)

      }
    }
  }, [])
  useEffect(() => {
    try {
      if (user) {
        if (user.permissions == "admin") {
          adminRequets.getAllTeachers().then(res => {
            setList(res)
          }
          )
        } else if (user.permissions == "teacher") {
          classRequets.getAllTeacherClasses(user.id).then(res => setList(res))
        }
      }
    } catch (error) {
      console.log("🚀error in get classroom list", error)
    }
  }, [user])
  return (
    <div>
      <popupContext.Provider value={{ popup, setPopup }}>
        <listControllerContext.Provider value={{ list, setList }}>
          <HeaderTextContext.Provider value={{ headerText, setHeaderText }}>
            <userContext.Provider value={{ user, setUser }}>
              <studentDataContext.Provider value={{ studentData, setstudentData, classData, setClassData }} >

                {children}

              </studentDataContext.Provider>
            </userContext.Provider>
          </HeaderTextContext.Provider>
        </listControllerContext.Provider>
      </popupContext.Provider>
    </div>
  );
}

export default AdminProvider;
